// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27currentColor%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276 9 12 15 18 9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Rubik:wght@400;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: 'Rubik', sans-serif;
  background-color: #F0F8E7;
  margin: 0;
  padding: 0;
}

.profile-container {
  background-color: #A5D6A7;
  border-radius: 20px;
  padding: 30px;
  width: 75%;
  max-width: 800px;
  margin: 50px auto;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.profile-heading {
  text-align: center;
  margin-bottom: 40px;
  font-size: 32px;
  font-weight: bold;
  color: #004D40;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.profile-form {
  display: flex;
  flex-direction: column;
}

.form-group {
  margin-bottom: 30px;
  width: 100%;
}

.form-group label {
  font-weight: bold;
  color: #004D40;
  margin-bottom: 10px;
  display: block;
}

.form-group-inline {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
}

.inline-input {
  width: 23%;
}

.inline-input-wide {
  width: 31%;
  margin-right: 20px; 
}

.inline-input-wide:last-child {
  margin-right: 0; 
}

.profile-input,
.profile-textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #B0BEC5;
  border-radius: 10px;
  box-sizing: border-box;
  margin-bottom: 20px;
}

.profile-input:read-only {
  background-color: #e0e0e0;
}

.profile-textarea {
  height: 40px;
}

.profile-textarea-large {
  height: 160px;
}

.update-button {
  padding: 10px 20px;
  border: none;
  background-color: #004D40;
  color: white;
  font-size: 16px;
  font-weight: bold;
  border-radius: 15px;
  cursor: pointer;
  width: 100%;
  max-width: 200px;
  text-align: center;
}

.update-button:hover {
  background-color: #00332F;
}

@media (min-width: 601px) {
  .form-row {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }

  .form-group {
    flex: 1 1;
  }

  .form-group-inline {
    display: flex;
    justify-content: space-between;
  }

  .update-button {
    width: 20%; 
    max-width: 150px; 
  }
}

@media (max-width: 600px) {
  .profile-container {
    width: 80%;
    padding: 20px;
  }

  .form-row {
    flex-direction: column;
  }

  .form-group-inline {
    flex-direction: column;
  }

  .inline-input,
  .inline-input-wide {
    width: 100%;
    margin-right: 0; 
  }

  .update-button {
    width: 100%;
  }
}

.success-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  pointer-events: none;
}

.popup-content {
  background: white;
  padding: 25px;
  text-align: center;
  border-radius: 15px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2);
  width: 300px;
  animation: fadeIn 0.3s ease-in-out;
}

.popup-content h3 {
  margin-bottom: 10px;
  font-size: 22px;
  color: #28a745;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.popup-content p {
  font-size: 16px;
  margin-bottom: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* .error-message4 {
  background-color: #ffcccc;
  color: #d32f2f;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 20px;
  text-align: center;
  width: 40%;
} */

.update-button {
  background: #004D40;
  color: white;
  border: none;
  padding: 12px 25px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 20px auto;
  display: block;
  width: 200px;
}

.update-button:active {
  transform: translateY(0);
}

.required-star {
  color: #d32f2f;
  margin-left: 4px;
}

.field-error {
  color: #d32f2f;
  font-size: 12px;
  margin-top: 5px;
  display: block;
}

.client-input:invalid, 
.client-textarea:invalid {
  border-color: #d32f2f;
}

.backend-error-message {
  background-color: #fde7e9;
  border-left: 4px solid #d32f2f;
  padding: 12px 20px;
  margin-bottom: 20px;
  border-radius: 4px;
  color: #d32f2f;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.backend-error-message p {
  margin: 0;
  padding: 0;
}

.error-message {
  color: #d32f2f;
  background-color: #fde7e9;
  border: 1px solid #d32f2f;
  padding: 12px;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 10px 0;
  font-weight: 600;
  width: 100%;
  max-width: 800px;
  margin: 0 auto 20px;
  justify-content: center;
}

@media (max-width: 600px) {
  .client-input,
  .client-textarea {
    width: 94% !important;
  }
}

.profile-input[type="text"],
.profile-input[type="number"],
.profile-input select {
  width: 100%;
  padding: 10px;
  border: 1px solid #B0BEC5;
  border-radius: 10px;
  box-sizing: border-box;
  margin-bottom: 20px;
  background-color: white !important;
}

.profile-input select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 1em;
}`, "",{"version":3,"sources":["webpack://./src/styles/ProfilePage.css"],"names":[],"mappings":"AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;;;;;;;GAQG;;AAEH;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;;IAEE,qBAAqB;EACvB;AACF;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,yDAA2R;EAC3R,4BAA4B;EAC5B,sCAAsC;EACtC,oBAAoB;AACtB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Rubik:wght@400;700&display=swap');\n\nbody {\n  font-family: 'Rubik', sans-serif;\n  background-color: #F0F8E7;\n  margin: 0;\n  padding: 0;\n}\n\n.profile-container {\n  background-color: #A5D6A7;\n  border-radius: 20px;\n  padding: 30px;\n  width: 75%;\n  max-width: 800px;\n  margin: 50px auto;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.profile-heading {\n  text-align: center;\n  margin-bottom: 40px;\n  font-size: 32px;\n  font-weight: bold;\n  color: #004D40;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.profile-form {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group {\n  margin-bottom: 30px;\n  width: 100%;\n}\n\n.form-group label {\n  font-weight: bold;\n  color: #004D40;\n  margin-bottom: 10px;\n  display: block;\n}\n\n.form-group-inline {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.inline-input {\n  width: 23%;\n}\n\n.inline-input-wide {\n  width: 31%;\n  margin-right: 20px; \n}\n\n.inline-input-wide:last-child {\n  margin-right: 0; \n}\n\n.profile-input,\n.profile-textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #B0BEC5;\n  border-radius: 10px;\n  box-sizing: border-box;\n  margin-bottom: 20px;\n}\n\n.profile-input:read-only {\n  background-color: #e0e0e0;\n}\n\n.profile-textarea {\n  height: 40px;\n}\n\n.profile-textarea-large {\n  height: 160px;\n}\n\n.update-button {\n  padding: 10px 20px;\n  border: none;\n  background-color: #004D40;\n  color: white;\n  font-size: 16px;\n  font-weight: bold;\n  border-radius: 15px;\n  cursor: pointer;\n  width: 100%;\n  max-width: 200px;\n  text-align: center;\n}\n\n.update-button:hover {\n  background-color: #00332F;\n}\n\n@media (min-width: 601px) {\n  .form-row {\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n  }\n\n  .form-group {\n    flex: 1;\n  }\n\n  .form-group-inline {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .update-button {\n    width: 20%; \n    max-width: 150px; \n  }\n}\n\n@media (max-width: 600px) {\n  .profile-container {\n    width: 80%;\n    padding: 20px;\n  }\n\n  .form-row {\n    flex-direction: column;\n  }\n\n  .form-group-inline {\n    flex-direction: column;\n  }\n\n  .inline-input,\n  .inline-input-wide {\n    width: 100%;\n    margin-right: 0; \n  }\n\n  .update-button {\n    width: 100%;\n  }\n}\n\n.success-popup {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  pointer-events: none;\n}\n\n.popup-content {\n  background: white;\n  padding: 25px;\n  text-align: center;\n  border-radius: 15px;\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2);\n  width: 300px;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.popup-content h3 {\n  margin-bottom: 10px;\n  font-size: 22px;\n  color: #28a745;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.popup-content p {\n  font-size: 16px;\n  margin-bottom: 0;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* .error-message4 {\n  background-color: #ffcccc;\n  color: #d32f2f;\n  padding: 10px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  text-align: center;\n  width: 40%;\n} */\n\n.update-button {\n  background: #004D40;\n  color: white;\n  border: none;\n  padding: 12px 25px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin: 20px auto;\n  display: block;\n  width: 200px;\n}\n\n.update-button:active {\n  transform: translateY(0);\n}\n\n.required-star {\n  color: #d32f2f;\n  margin-left: 4px;\n}\n\n.field-error {\n  color: #d32f2f;\n  font-size: 12px;\n  margin-top: 5px;\n  display: block;\n}\n\n.client-input:invalid, \n.client-textarea:invalid {\n  border-color: #d32f2f;\n}\n\n.backend-error-message {\n  background-color: #fde7e9;\n  border-left: 4px solid #d32f2f;\n  padding: 12px 20px;\n  margin-bottom: 20px;\n  border-radius: 4px;\n  color: #d32f2f;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n}\n\n.backend-error-message p {\n  margin: 0;\n  padding: 0;\n}\n\n.error-message {\n  color: #d32f2f;\n  background-color: #fde7e9;\n  border: 1px solid #d32f2f;\n  padding: 12px;\n  border-radius: 5px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 10px 0;\n  font-weight: 600;\n  width: 100%;\n  max-width: 800px;\n  margin: 0 auto 20px;\n  justify-content: center;\n}\n\n@media (max-width: 600px) {\n  .client-input,\n  .client-textarea {\n    width: 94% !important;\n  }\n}\n\n.profile-input[type=\"text\"],\n.profile-input[type=\"number\"],\n.profile-input select {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #B0BEC5;\n  border-radius: 10px;\n  box-sizing: border-box;\n  margin-bottom: 20px;\n  background-color: white !important;\n}\n\n.profile-input select {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  background-size: 1em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
